import { OpenFinanceBankTypes } from '@ibk/contabilidade-digital';
import { banrisulLogo, bbLogo, bradescoLogo, c6bankLogo, caixaLogo, interLogo, itauLogo, nubankLogo, pluggyLogo, santanderLogo, sicobLogo, sicrediLogo, unicredLogo, } from '@ibk/shared-assets';
export const bankLogos = {
    [OpenFinanceBankTypes.BANCO_DO_BRASIL]: bbLogo,
    [OpenFinanceBankTypes.BRADESCO]: bradescoLogo,
    [OpenFinanceBankTypes.BANRISUL]: banrisulLogo,
    [OpenFinanceBankTypes.CAIXA]: caixaLogo,
    [OpenFinanceBankTypes.ITAU]: itauLogo,
    [OpenFinanceBankTypes.NUBANK]: nubankLogo,
    [OpenFinanceBankTypes.SANTANDER]: santanderLogo,
    [OpenFinanceBankTypes.SICOOB]: sicobLogo,
    [OpenFinanceBankTypes.SICREDI]: sicrediLogo,
    [OpenFinanceBankTypes.UNICRED]: unicredLogo,
    [OpenFinanceBankTypes.PLUGGY]: pluggyLogo,
    [OpenFinanceBankTypes.INTER]: interLogo,
    [OpenFinanceBankTypes.C6_BANK]: c6bankLogo,
};
const bankCodeToType = {
    '001': OpenFinanceBankTypes.BANCO_DO_BRASIL,
    '237': OpenFinanceBankTypes.BRADESCO,
    '041': OpenFinanceBankTypes.BANRISUL,
    '104': OpenFinanceBankTypes.CAIXA,
    '341': OpenFinanceBankTypes.ITAU,
    '260': OpenFinanceBankTypes.NUBANK,
    '033': OpenFinanceBankTypes.SANTANDER,
    '756': OpenFinanceBankTypes.SICOOB,
    '748': OpenFinanceBankTypes.SICREDI,
    '136': OpenFinanceBankTypes.UNICRED,
    '077': OpenFinanceBankTypes.INTER,
    '336': OpenFinanceBankTypes.C6_BANK,
};
export function getBankLogo(bankName, bankCode) {
    if (!bankName && !bankCode) {
        return undefined;
    }
    let bankType;
    if (bankCode) {
        const normalizedCode = bankCode.toUpperCase().trim();
        if (normalizedCode === 'PLUGGY' || normalizedCode === 'PLUGGY BANK BUSINESS') {
            bankType = OpenFinanceBankTypes.PLUGGY;
        }
        else if (bankCodeToType[bankCode]) {
            bankType = bankCodeToType[bankCode];
        }
    }
    if (!bankType && bankName) {
        const normalizedName = bankName.toUpperCase().trim();
        if (normalizedName === 'PLUGGY' || normalizedName === 'PLUGGY BANK BUSINESS') {
            bankType = OpenFinanceBankTypes.PLUGGY;
        }
        else {
            const nameAsType = normalizedName;
            if (bankLogos[nameAsType]) {
                bankType = nameAsType;
            }
        }
    }
    if (bankType) {
        return bankLogos[bankType];
    }
    return undefined;
}
